//
// Style.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "./AttributePriority";
import "./NamedStyleMap";
import "./AttributeBundle";

var Style = createModule("commons::Style", [], EventDispatcher, [
    {
        STYLE_CHANGED: 10052,
    },
    ,
    ,
    {
        attributePriority: 4,
        name: 7,
        theme: 7,
        parentStyle: 1,
    },
    {
        getNumberOfKPIRangeStyleElements: [4],
        initAttributeDefaults: [0],
        getCSS: [7,2,2,2],
        updateKPIRangeStyleElements: [0],
        getLocalAttributeBundleForStyleElement: [1,4],
        getNumberOfGraphDataStyleElements: [4],
        clear: [0],
        getDescription: [7],
        getGraphDataAttributeBundleAtIndex: [1,4],
        updateGraphDataNodeStyleElements: [0],
        updateGraphDataStyleElements: [0],
        addAttributeBundlesDefinedInCSSFile: [0,7],
        getNumberOfGraphDataNodeStyleElements: [4],
        addAttributeBundlesDefinedInCSSString: [0,7],
        getAttributeBundleForPredefinedStyleElement: [1,4],
        getGraphDataNodeStyleElementAtIndex: [1,4],
        getAttributeBundleForStyleElement: [1,4],
        resolveExpressions: [0,1],
    },
    {
        _create_s: [4,7],
        _create_n: [4,4],
        getSharedInstance: [1],
        instance: [1],
        getStyleElementForName: [4,7],
        setDefaultGlobalStyleType: [0,4],
        createStyleMap: [1,7,7],
        getCombinedCSS: [7,1,7,2,2],
    },
    ,
    ["_create"]
]);
export default Style;
